import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "send-plane-line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M18.1056 2.46381L13.5611 18.369C13.4354 18.8094 13.1649 18.8294 12.9636 18.4269L9.16665 10.833L1.6024 7.80736C1.17767 7.63746 1.18292 7.38321 1.63077 7.23393L17.536 1.93221C17.9763 1.78541 18.2289 2.03191 18.1056 2.46381ZM15.8627 4.24675L5.67682 7.64207L10.374 9.52095L12.9079 14.5887L15.8627 4.24675Z",
			fill: "currentColor"
		})
	})
});
export default SvgRefer;
